import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import timeTrackingService from '../../services/timeTrackingService';
import projectService from '../../services/projectService';
import taskService from '../../services/taskService';
import TimeEntryTimer from '../../components/TimeTracking/TimeEntryTimer';
import TimeEntryList from '../../components/TimeTracking/TimeEntryList';

const TimeTracking = () => {
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState({});

  // Fetch time entries
  const { data: timeEntriesData, isLoading: entriesLoading, refetch } = useQuery({
    queryKey: ['timeEntries', filters],
    queryFn: () => timeTrackingService.getAllTimeEntries(filters),
  });

  // Fetch projects for dropdowns
  const { data: projectsData } = useQuery({
    queryKey: ['projects'],
    queryFn: async () => {
      const response = await projectService.getAllProjects({ limit: 1000 });
      console.log(projectsData);
      return response;
    },
  });

  // Fetch tasks for dropdowns
  const { data: tasksData } = useQuery({
    queryKey: ['tasks'],
    queryFn: async () => {
      const response = await taskService.getAllTasks({ limit: 1000 });
            console.log(tasksData);

      return response;
    },
  });

  // Delete mutation
  const deleteMutation = useMutation({
    mutationFn: timeTrackingService.deleteTimeEntry,
    onSuccess: () => {
      queryClient.invalidateQueries(['timeEntries']);
      toast.success('Time entry deleted successfully');
    },
    onError: (error) => {
      toast.error(error.response?.data?.error || 'Failed to delete time entry');
    },
  });

  const handleTimerStop = () => {
    // Refresh the list when timer is stopped
    refetch();
  };

  const handleRefresh = (newFilters) => {
    setFilters(newFilters);
  };

  const handleDelete = async (id) => {
    await deleteMutation.mutateAsync(id);
  };

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Time Tracking</h1>
          <p className="mt-1 text-sm text-gray-600">
            Track your time, manage entries, and view statistics
          </p>
        </div>
        <Link
          to="/app/time-tracking/new"
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          <FiPlus className="mr-2" />
          Manual Entry
        </Link>
      </div>

      {/* Timer Component */}
      <TimeEntryTimer
        onTimerStop={handleTimerStop}
        projects={projectsData?.projects || []}
        tasks={tasksData?.tasks || []}
      />

      {/* Time Entries List */}
      {entriesLoading ? (
        <div className="bg-white rounded-lg shadow p-12 text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading time entries...</p>
        </div>
      ) : (
        <TimeEntryList
          entries={timeEntriesData?.data || []}
          onDelete={handleDelete}
          onRefresh={handleRefresh}
          projects={projectsData?.projects || []}
          tasks={tasksData?.data || []}
        />
      )}
    </div>
  );
};

export default TimeTracking;


